// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"324":"e5db287a","877":"eb7c0e8a"}[chunkId] + ".css";
};